import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Nfc, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      navigate(data.user.must_change_credentials ? "/setup" : "/");
    } catch (err) {
      setError(apiErr(err, "Login fallito"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-900 p-6">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-3xl bg-gradient-to-br from-indigo-500 to-indigo-700 shadow-lg shadow-indigo-500/30">
            <Nfc className="text-white" size={30} />
          </div>
          <h1 className="font-display text-3xl font-extrabold text-white">TapCard Manager</h1>
          <p className="mt-1 text-sm text-slate-400">Gestione carte NFC digitali</p>
        </div>
        <form onSubmit={submit} className="rounded-3xl border border-white/10 bg-white/5 p-7 backdrop-blur-xl space-y-4">
          <div className="space-y-1.5">
            <Label className="text-slate-300">Email</Label>
            <Input data-testid="input-login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="bg-white/5 border-white/10 text-white placeholder:text-slate-500" placeholder="admin@esempio.com" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300">Password</Label>
            <Input data-testid="input-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="bg-white/5 border-white/10 text-white placeholder:text-slate-500" placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
          <Button data-testid="btn-login-submit" type="submit" disabled={loading} className="w-full h-12 bg-indigo-600 hover:bg-indigo-700 text-base font-semibold">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Accedi"}
          </Button>
        </form>
      </div>
    </div>
  );
}
